import React from "react";
import { motion } from "framer-motion";
import { fleetrifyIcons } from "../../../../assets/icons/icons";

interface SummaryCardProps {
    title: string;
    value: string | number;
    changeText: string;
    changeDirection?: "up" | "down" | "mid"; 
    icon?: React.ReactNode;
    hideChangeIndicator?: boolean;
}

export const DashboardFleetSummaryCard: React.FC<SummaryCardProps> = ({
    title,
    value,
    changeText,
    icon,
    changeDirection,
    hideChangeIndicator = false,
}) => {
    const isUp = changeDirection === "up";
    const isMid = changeDirection === "mid";
    
    return (
        <motion.div
            className="bg-white rounded-[12px] shadow-sm p-4 h-[150px] flex flex-col justify-between border border-gray-200 w-full cursor-default"
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.38, ease: "easeOut" }}
            whileHover={{ y: -4, boxShadow: "0 10px 28px rgba(20,56,135,0.13)" }}
        >
            <div className="space-y-2">
                <div className="flex items-center justify-between">
                    <h4 className="text-sm font-medium text-[#00032A]">{title}</h4>
                    <motion.div
                        whileHover={{ scale: 1.25, rotate: 10 }}
                        transition={{ type: "spring", stiffness: 400, damping: 10 }}
                    >
                        {icon}
                    </motion.div>
                </div>
                <p className="text-xl font-bold text-[#143887] mt-1">{value}</p>
            </div>
            
            {/* Only show change indicator if not hidden and changeDirection exists */}
            {!hideChangeIndicator && changeDirection && (
                <div
                    className={`flex items-center gap-1 mt-1 text-xs font-medium ${
                        isUp ? "text-green-600" : isMid ? "text-blue-500"    : "text-red-500"
                    }`}
                >
                    {isUp ? fleetrifyIcons.rateUp : isMid ? fleetrifyIcons.rateNeutral : fleetrifyIcons.rateDown}
                    {changeText}
                </div>
            )}
            
            {/* Show plain text if hideChangeIndicator is true */}
            {hideChangeIndicator && (
                <div className="mt-1 text-xs font-medium text-gray-600">
                    {changeText}
                </div>
            )}
        </motion.div>
    );
};